module.exports = __webpack_public_path__ + "static/media/Inter.0930073e.ttf";